// axios
import axios from 'axios';
// routes
import { routes } from "../../features/routes/route";
// config
import { config2 } from "../../config/chargeConfig";

export const UserCharge = async (data: any) => {
    const { data: response } = await axios.post(`${routes.api[0].address}Ipg/Token`, {
        phoneNumber: data
    }, config2);
    return response;
};

export const UserChargeTest = async (data: any) => {
    const { data: response } = await axios.post(`${routes.api[0].address}Ipg/TokenTest`, {
        phoneNumber: data
    }, config2);
    return response;
};
